import React from 'react';
import shorterTotal from '../util/shorterTotal';

export default class ShareButton extends React.PureComponent {
  static propTypes = {
    url: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    type: React.PropTypes.oneOf(['facebook', 'twitter']),
    getCount: React.PropTypes.func.isRequired,
    popup: React.PropTypes.func.isRequired,
    suffix: React.PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      total: false,
    };
  }

  componentDidMount() {
    this.getCount();
  }

  async getCount() {
    const shares = await this.props.getCount(this.props.url);

    this.setState({
      total: shares,
    });
  }

  render() {
    const total = this.props.suffix ? shorterTotal(this.state.total) : this.state.total;
    return (
      <button
        className={`share-button share-${this.props.type}`}
        onClick={() => this.props.popup(this.props.title, this.props.url)}
      >
        <span className="icon-container">
          <i className={`icon-${this.props.type}`}></i>
        </span>

        <span className="structural">{this.props.type}</span> {total && <span className="share-count">{total}</span>}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ShareButton.jsx